module.exports = __webpack_public_path__ + "static/img/wx-img.0c2f1ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx-img.jpg
// module id = 0m1F
// module chunks = 1